import { Routes } from '@angular/router';
import { rolesGuard } from './Core/Roles/Guard/roles.guard';
import { 
  INSTITUTIONS_LINK_ALLOWED, 
  USER_LINK_ALLOWED, 
  ACCESS_CODES_LINK_ALLOWED
} from './Core/Roles/Models/roles.model';

export const routes: Routes = [
  // Public routes (no guards)
  { 
    path: 'login', 
    loadComponent: () => import('./UI/Login/login.component').then(m => m.LoginComponent)
  },

  // Authenticated routes with persistent header and sidebar layout
  {
    path: '',
    canActivate: [rolesGuard],
    loadComponent: () => import('./UI/Home/home.component').then(m => m.HomeComponent),
    children: [
      // Institution management routes
      {
        path: 'institution-search',
        canActivate: [rolesGuard],
        data: { roleNamesAllowed: INSTITUTIONS_LINK_ALLOWED },
        loadComponent: () => import('./UI/Institutions/InstitutionSearch/institution-search.component').then(m => m.InstitutionSearchComponent)
      },
      {
        path: 'institution-profile/:id',
        canActivate: [rolesGuard],
        data: { roleNamesAllowed: INSTITUTIONS_LINK_ALLOWED },
        loadComponent: () => import('./UI/Institutions/InstitutionProfile/institution-profile.component').then(m => m.InstitutionProfileComponent)
      },

      // User management routes
      {
        path: 'user-search',
        canActivate: [rolesGuard],
        data: { roleNamesAllowed: USER_LINK_ALLOWED },
        loadComponent: () => import('./UI/Users/UserSearch/user-search.component').then(m => m.UserSearchComponent)
      },
      {
        path: 'user-profile/:id',
        canActivate: [rolesGuard],
        data: { roleNamesAllowed: USER_LINK_ALLOWED },
        loadComponent: () => import('./UI/Users/UserProfile/user-profile.component').then(m => m.UserProfileComponent)
      },

      // Access codes management - shown in side nav if user has appropriate roles  
      // Roles: ['superAdmin', 'salesops']
      {
        path: 'access-codes',
        canActivate: [rolesGuard],
        data: { roleNamesAllowed: ACCESS_CODES_LINK_ALLOWED },
        loadComponent: () => import('./UI/AccessCodeGeneration/access-code-generation.component').then(m => m.AccessCodeGenerationComponent)
      },
      {
        path: 'access-codes/:batchId',
        canActivate: [rolesGuard],
        data: { roleNamesAllowed: ACCESS_CODES_LINK_ALLOWED },
        loadComponent: () => import('./UI/AccessCodeGeneration/ViewAccessCodes/view-access-codes.component').then(m => m.ViewAccessCodesComponent)
      },

      // Access denied page - no guard needed, any authenticated user should be able to see this
      {
        path: 'access-denied',
        loadComponent: () => import('./UI/AccessDenied/access-denied.component').then(m => m.AccessDeniedComponent)
      },

      // Default redirect for authenticated users
      { path: '', redirectTo: 'institution-search', pathMatch: 'full' }
    ]
  },

  // Catch-all redirect
  { path: '**', redirectTo: '/login' }
];
